import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faExplosion,
  faPhoneVolume,
  faPeopleGroup,
  faTools
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useWizardFormContext } from 'providers/WizardFormProvider';
import { Nav } from 'react-bootstrap';

const WizardNavItem = ({
  icon,
  label,
  step
}: {
  icon: IconProp;
  label: string;
  step: number;
}) => {
  const { selectedStep, totalStep } = useWizardFormContext();
  return (
    <Nav.Item as="li" className="nav-item">
      <Nav.Link
        className={classNames('fw-semibold', {
          done: selectedStep > step && step !== totalStep,
          complete: selectedStep > step && step !== totalStep - 1
        })}
        eventKey={step}
      >
        <div className="text-center d-inline-block">
          <span className="nav-item-circle-parent">
            <span className="nav-item-circle">
              <FontAwesomeIcon icon={icon} />
            </span>
          </span>
          <span className="d-none d-md-block mt-1 fs-9">{label}</span>
        </div>
      </Nav.Link>
    </Nav.Item>
  );
};

const WizardNav = () => {
  return (
    <Nav className="justify-content-between nav-wizard">
      <WizardNavItem icon={faExplosion} step={1} label="Basic" />
      <WizardNavItem icon={faTools} step={2} label="Advance" />
      <WizardNavItem icon={faPhoneVolume} step={3} label="Outbound" />
      <WizardNavItem icon={faPeopleGroup} step={4} label="Call List" />
      <WizardNavItem icon={faCheck} step={5} label="Done" />
    </Nav>
  );
};

export default WizardNav;
